const INITIAL_STATE = {
  data: {},
  errors: {},
      
}
const GetSingleServiceOrder = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_SINGLE_SERVICE_ORDER_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_SINGLE_SERVICE_ORDER_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
      
export default GetSingleServiceOrder;